export enum DateRangeType {
  date = 1,
  month = 2,
  year = 3
}

export const DateRangeUnitStrings = {
  [DateRangeType.date]: "day",
  [DateRangeType.month]: "month",
  [DateRangeType.year]: "year",
}
